module.exports = __webpack_public_path__ + "static/img/6.afa1e18.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/sp/6.png
// module id = ikRk
// module chunks = 0